module.exports = __webpack_public_path__ + "static/media/special-stone-active.a8b2bd61.svg";